export default __webpack_public_path__ + "static/banner-activities-1972655afea326c7917c08beaf45925c.jpg";